import FingerprintJS from '@fingerprintjs/fingerprintjs'

declare global {
  interface Window {
    deviceCode?: string
  }
}

export function getDeviceCode(): Promise<string> {
  return new Promise((resolve) => {
    if (window.deviceCode)
      return resolve(window.deviceCode)
    const fpPromise = FingerprintJS.load()
    fpPromise
      .then(fp => fp.get())
      .then((result) => {
        window.deviceCode = result.visitorId
        resolve(result.visitorId)
      })
  })
}
